import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P14-E1",
    audio: "img/FriendsPlus/Page14/Audio/audio-e1-p14.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page14/E1/1.jpg" },
        {
          url: "img/FriendsPlus/Page14/E1/2.jpg",
          audioUrl: "img/FriendsPlus/Page14/Audio/tieude-e1-p14.mp3",
        },
        { url: "img/FriendsPlus/Page14/E1/3.jpg" },
      ],
      [
        // Column2
        { url: "img/FriendsPlus/Page14/E1/4.jpg" },
        {
          url: "img/FriendsPlus/Page14/E1/5.jpg",
          audioUrl: "img/FriendsPlus/Page14/Audio/table.mp3",
        },
        { url: "img/FriendsPlus/Page14/E1/6.jpg" },
        {
          url: "img/FriendsPlus/Page14/E1/7.jpg",
          audioUrl: "img/FriendsPlus/Page14/Audio/computer.mp3",
        },
        { url: "img/FriendsPlus/Page14/E1/8.jpg" },
        {
          url: "img/FriendsPlus/Page14/E1/9.jpg",
          audioUrl: "img/FriendsPlus/Page14/Audio/coat hook.mp3",
        },
        { url: "img/FriendsPlus/Page14/E1/10.jpg" },
        {
          url: "img/FriendsPlus/Page14/E1/11.jpg",
          audioUrl: "img/FriendsPlus/Page14/Audio/pencil case.mp3",
        },
        { url: "img/FriendsPlus/Page14/E1/12.jpg" },
        {
          url: "img/FriendsPlus/Page14/E1/13.jpg",
          audioUrl: "img/FriendsPlus/Page14/Audio/board.mp3",
        },
        { url: "img/FriendsPlus/Page14/E1/14.jpg" },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page14/E1/15.jpg" },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P14-E2",
    audio: "img/FriendsPlus/Page14/Audio/audio-e2-p14.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page14/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page14/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page14/Audio/tieude-e2-p14.mp3",
        },
        { url: "img/FriendsPlus/Page14/E2/3.jpg" },
      ],
      [
        // Column2
        { url: "img/FriendsPlus/Page14/E2/4.jpg" },
        {
          url: "img/FriendsPlus/Page14/E2/5.jpg",
          audioUrl: "img/FriendsPlus/Page14/Audio/table.mp3",
        },
        { url: "img/FriendsPlus/Page14/E2/6.jpg" },
        {
          url: "img/FriendsPlus/Page14/E2/7.jpg",
          audioUrl: "img/FriendsPlus/Page14/Audio/computer.mp3",
        },
        { url: "img/FriendsPlus/Page14/E2/8.jpg" },
        {
          url: "img/FriendsPlus/Page14/E2/9.jpg",
          audioUrl: "img/FriendsPlus/Page14/Audio/coat hook.mp3",
        },
        { url: "img/FriendsPlus/Page14/E2/10.jpg" },
        {
          url: "img/FriendsPlus/Page14/E2/11.jpg",
          audioUrl: "img/FriendsPlus/Page14/Audio/pencil case.mp3",
        },
        { url: "img/FriendsPlus/Page14/E2/12.jpg" },
        {
          url: "img/FriendsPlus/Page14/E2/13.jpg",
          audioUrl: "img/FriendsPlus/Page14/Audio/board.mp3",
        },
        { url: "img/FriendsPlus/Page14/E2/14.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page14/E2/15.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 2",
    id: "SB4-U2-P14-E3",
    audio: "img/FriendsPlus/Page14/Audio/audio-e3-p14.mp3",
    video: "Videos/e3.p14.mp4",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page14/E3/1.jpg" },
        { url: "img/FriendsPlus/Page14/E3/2.jpg", audioUrl: "img/FriendsPlus/Page14/Audio/tieude-e3-p14.mp3", },
        { url: "img/FriendsPlus/Page14/E3/3.jpg" },
      ],
      [
        // Column2
        { url: "img/FriendsPlus/Page14/E3/4.jpg", audioUrl: "img/FriendsPlus/Page14/Audio/hinh1-e3-p14.mp3", },
        { url: "img/FriendsPlus/Page14/E3/5.jpg", audioUrl: "img/FriendsPlus/Page14/Audio/hinh2-e3-p14.mp3", },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page14/E3/6.jpg", audioUrl: "img/FriendsPlus/Page14/Audio/hinh3-e3-p14.mp3", },
        { url: "img/FriendsPlus/Page14/E3/7.jpg", audioUrl: "img/FriendsPlus/Page14/Audio/hinh4-e3-p14.mp3", },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page14/E3/8.jpg", audioUrl: "img/FriendsPlus/Page14/Audio/hinh5-e3-p14.mp3", },
        { url: "img/FriendsPlus/Page14/E3/9.jpg", audioUrl: "img/FriendsPlus/Page14/Audio/hinh6-e3-p14.mp3", },
      ],
    ],
  },
};

export default json;
